import React from 'react';
import {switchApi, authCheck, getManagers, getResellers, getReseller, addReseller, editReseller, delReseller} from '../Api';
import Modal from '../components/Modal';
import ModalReseller from '../components/ModalReseller';
import $ from 'jquery';
import Toast from '../components/Toast';
import Sidebar from '../components/Sidebar';
import ResellerTable from '../components/ResellerTable';

export default class PageResellers extends React.Component {

    state = {
        toasts: [],
        resellers: [],
        reseller: {},
        _id: 0,
        _company: '',
        _address: '',
        _description: '',
        _phone: '',
        _email: '',
        _firstName: '',
        _lastName: '',
        _password: '',
        _managerId: 0,
        _poolUrl: '',
        _poolUser: '',
        _poolPass: '',
    }

    toast(title, content){
        let toasts = this.state.toasts;
        let i = toasts.push({
            title: title,
            content: content
        });
        this.setState({toasts},()=>{
            $('#toast_'+(i-1)).toast({delay: 5000});
            $('#toast_'+(i-1)).toast('show');
        });        
    }

    componentDidMount(){
        this.isMount = true;
        this.apiAuthCheck();
    }

    componentWillUnmount(){
        this.isMount = false;
    }

    changeState(state, value){
        if (this.isMount) this.setState({[state]: value});
    }

    
    apiAuthCheck(){
        authCheck()
        .then((data)=>{
            if ((data.status === 200)&&(data.data.user)){
                if (this.isMount) this.setState({user: data.data.user});
                this.apiGetManagers();
                this.apiGetResellers();
            }else{
                console.log(data);
                this.props.history.push('/');
            }          
        })
        .catch((err)=>{
            console.log(err);
            if (err.code === 'ECONNABORTED') {
                switchApi();
                this.apiAuthCheck();
            }else{
                this.props.history.push('/');
            }
        });
    }

    apiGetManagers(){
        getManagers()
        .then((data)=>{
            if ((data.status === 200)&&(data.data.managers)){
                if (this.isMount) this.setState({managers: data.data.managers});                
            }else{
                console.log(data);
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }

    apiGetResellers(){
        getResellers()
        .then((data)=>{
            if ((data.status === 200)&&(data.data.resellers)){
                if (this.isMount) this.setState({resellers: data.data.resellers});                
            }else{
                console.log(data);
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    modalAddReseller(){
        this.setState({
            _company: '',
            _address: '',
            _description: '',
            _phone: '',
            _email: '',
            _firstName: '',
            _lastName: '',
            _password: '',
            _managerId: 0,
            _poolUrl: '',
            _poolUser: '',
            _poolPass: '',
        }, ()=>{
            $('#modalAddReseller').modal('show');
        });
    }


    apiAddReseller(){
        addReseller({
            company: this.state._company,
            address: this.state._address,
            description: this.state._description,
            phone: this.state._phone,
            email: this.state._email,
            firstName: this.state._firstName,
            lastName: this.state._lastName,
            password: this.state._password,
            managerId: this.state._managerId,
            poolUrl: this.state._poolUrl,
            poolUser: this.state._poolUser,
            poolPass: this.state._poolPass,
        })
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalAddReseller').modal('hide');
                this.toast('Success', 'Saved');
                this.apiGetResellers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });     
    }


    modalEditReseller(i){
        let _id = this.state.resellers[i].id;
        getReseller(_id)
        .then((data)=>{
            if ((data.status === 200)&&(data.data.reseller)){
                if (this.isMount) this.setState({
                    _id,
                    _company: (data.data.reseller.company) ? data.data.reseller.company : '',
                    _address: (data.data.reseller.address) ? data.data.reseller.address : '',
                    _description: (data.data.reseller.description) ? data.data.reseller.description : '',
                    _phone: (data.data.reseller.phone) ? data.data.reseller.phone : '',
                    _email: (data.data.reseller.email) ? data.data.reseller.email : '',
                    _firstName: (data.data.reseller.firstName) ? data.data.reseller.firstName : '',
                    _lastName: (data.data.reseller.lastName) ? data.data.reseller.lastName : '',
                    _managerId: (data.data.reseller.manager) ? data.data.reseller.manager.id : 0,
                    _poolUrl: (data.data.reseller.poolUrl) ? data.data.reseller.poolUrl : '',
                    _poolUser: (data.data.reseller.poolUser) ? data.data.reseller.poolUser : '',
                    _poolPass: (data.data.reseller.poolPass) ? data.data.reseller.poolPass : '',
                }, ()=>{
                    $('#modalEditReseller').modal('show');
                });
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    apiEditReseller(){
        editReseller(this.state._id, {
            company: this.state._company,
            address: this.state._address,
            description: this.state._description,
            phone: this.state._phone,
            email: this.state._email,
            firstName: this.state._firstName,
            lastName: this.state._lastName,
            poolUrl: this.state._poolUrl,
            poolUser: this.state._poolUser,
            poolPass: this.state._poolPass,
        })
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalEditReseller').modal('hide');
                this.toast('Success', 'Saved');
                this.apiGetResellers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    modalDelReseller(i){
        let _id = this.state.resellers[i].id;
        this.setState({
            _id
        }, ()=>{
            $('#modalDelReseller').modal('show');
        });
    }


    apiDelReseller(){
        delReseller(this.state._id)
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalDelReseller').modal('hide');
                this.toast('Success', 'Deleted');
                this.apiGetResellers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            // this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    render() {
        return (
            (!this.state.user)
            ?<div className="app"></div>
            :<div className="app">
                <Sidebar history={this.props.history} user={this.state.user} customer={this.state.customer} customerId={this.state.customerId}/>
                <div className="app-content">
                    <div className="page page-users">
                        <div className="toasts">
                            {(this.state.toasts) &&
                                this.state.toasts.map((toast, i)=>{
                                    return <Toast key={i} id={'toast_'+i} title={toast.title} content={toast.content} />
                                })
                            }
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1 className="page-title">Resellers
                                </h1>
                            </div>
                            <div className="col text-right">
                                {(this.state.user.userType.permissions.find((el) => el.id === 11)) &&
                                    <button className="btn btn-primary"
                                    onClick={this.modalAddReseller.bind(this)}
                                    >New Reseller</button>
                                }
                            </div>
                        </div>             
                        <div className="row">
                            <div className="col-lg-12 mt-4">
                                <ResellerTable 
                                    user={this.state.user}
                                    resellers={this.state.resellers}
                                    editFunction={this.modalEditReseller.bind(this)}
                                    deleteFunction={this.modalDelReseller.bind(this)}
                                />
                            </div>
                        </div>                
                    </div>
                </div>
                <ModalReseller
                    id="modalAddReseller"
                    title="Add Reseller"
                    changeState={this.changeState.bind(this)}
                    saveFunction={this.apiAddReseller.bind(this)}
                    managers={this.state.managers}
                    _company = {this.state._company}
                    _address = {this.state._address}
                    _description = {this.state._description}
                    _phone = {this.state._phone}
                    _email = {this.state._email}
                    _firstName = {this.state._firstName}
                    _lastName = {this.state._lastName}
                    _password = {this.state._password}
                    _managerId = {this.state._managerId}
                    _poolUrl = {this.state._poolUrl}
                    _poolUser = {this.state._poolUser}
                    _poolPass = {this.state._poolPass}
                />
                <ModalReseller
                    id="modalEditReseller"
                    title="Edit Reseller"
                    changeState={this.changeState.bind(this)}
                    saveFunction={this.apiEditReseller.bind(this)}
                    managers={this.state.managers}
                    _company = {this.state._company}
                    _address = {this.state._address}
                    _description = {this.state._description}
                    _phone = {this.state._phone}
                    _email = {this.state._email}
                    _firstName = {this.state._firstName}
                    _lastName = {this.state._lastName}
                    _managerId = {this.state._managerId}
                    _poolUrl = {this.state._poolUrl}
                    _poolUser = {this.state._poolUser}
                    _poolPass = {this.state._poolPass}
                />
                <Modal 
                    id="modalDelReseller"
                    title="Delete Reseller"
                    content="Are you sure?"
                    confirmText="Delete"
                    confirmFunction={this.apiDelReseller.bind(this)}
                />    
            </div>        
        );
    }
}